import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import { MINUTE_IN_MS } from '@/modules/shared/constants/time'

interface Payload {
  available: boolean
}

/**
 * Czy dla tej firmy wysyłka do BFM jest włączona. Steruje widocznością eksportu
 * "Kwoty wysyłane do BFM" — pokazujemy go tylko tam, gdzie BFM jest skonfigurowany,
 * zamiast zaszywać nazwę firmy po stronie klienta.
 */
export function useBfmPayrollAvailableQuery(companyId: string) {
  return useQuery<Payload>({
    queryKey: ['bfm-payroll-available', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<Payload>(
        `/api/${companyId}/timesheet/bfmPayrollAvailable`,
      )
      return data
    },
    enabled: !!companyId,
    staleTime: MINUTE_IN_MS * 30,
  })
}
